<template>
	<div class="report_container full" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.3)">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="显示未同步" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<vxe-grid class="" v-bind="gridOptions" :key="gridKey" v-if="gridOptions"
					@toolbar-button-click="toolbarButtonClickEvent" :ref="reportName+'_list'">
				</vxe-grid>				
				<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
				<reconciliation ref="reconciliation" />
			</el-main>
		</el-container>
		<exportTable :ref="exportRef" :forms="forms" :tableColumn="tableColumn" :reportName="reportName"
			:windowName="windowName" :afterexport="afterexport" listType="report" />
		<invoiceConfig ref="invoiceConfig" :invoicedata="invoicedata" :tab="['invoice']" title="发票预览" />	
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import reconciliation from '@/components/forms/collection/reconciliation/index.vue'
	import reportBase from '@_system/components/base/report.js'
	import exportTable from '@_system/components/export/index.vue'
	import invoiceConfig from '@/components/reports/reconciliationbankflow/lib/invoice/index.vue'
	export default {
		mixins: [reportBase],
		name: 'report',
		props: {

		},
		data() {
			return {
				invoicedata:{},
				showUnsendjindie:false,
				footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总金额',
				}, {
					type: 'field',
					field: 'amount',
					toFixed: 4
				}, {
					type: 'field',
					field: 'needamount',
					toFixed: 4
				}],
				showFooter: true,
				reportName: 'collection',
				windowName: '财审',
				exportRef: Math.random(),
				loading: false,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},
			beforeCreateGrid(formConfig, columns,gridOptions) {
				gridOptions.checkboxConfig = null
				columns.forEach((item)=>{
					if(item.field=='invoicecode'){
						item.slots = {
							default: ({row}) => {	
								if(row.invoiceStatus==3){
									if(row.invoiceId){
										return <el-link style="font-size:12px;" type="danger" onClick={()=>{this.preview(row)}} >{row.invoicecode}</el-link>
									}else{
										return <span style="color:#F56C6C">{row.invoicecode}</span>
									}									
								}else{
									if(row.invoiceId){
										return <el-link style="font-size:12px;" type="primary" onClick={()=>{this.preview(row)}} >{row.invoicecode}</el-link>
									}else{
										return <span >{row.invoicecode}</span>
									}									
								}
							}
						}
					}
					if(item.field=='resultamount'){
						item.slots = {
							default: ({row}) => {	
								if(row.invoiceStatus==3){
									if(row.invoiceId){
										return <span style="color:#F56C6C">{-Math.abs(row.resultamount)}</span>
									}else{
										return <span>{row.resultamount}</span>
									}									
								}else{
									return <span>{row.resultamount}</span>								
								}
							}
						}
					}
				})
			},
			preview(row){
				//console.log(row)
				this.invoicedata = {
					invoiceNumber:row.invoicecode,
					customerId:row.customerId,
					invoiceId:row.invoiceId,
					invoiceType:row.invoiceType
				}
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})
			},
			syninvoice(){
				let data =  this.$refs[this.reportName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				let param = []
				data.forEach((item)=>{
					if(item.invoicecode){
						param.push({
							id:item.id,
							collectionorderid:item.collectionorderid,
							invoicecode:item.invoicecode,
							invoiceordercodeid:item.invoiceordercodeid,
						})
					}
				})
				this.loading = true
				this.$api.collection.syninvoice({data:param}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})				
				console.log(param)
			},
			
			// sendjindie(){
			// 	let data =  this.$refs[this.reportName + '_list'].getCheckboxRecords()
			// 	if(!data.length){
			// 		this.$message.error('请选择数据')
			// 		return
			// 	}
			// 	this.loading = true
			// 	let ids = data.map((item)=>{
			// 		return item.collectionorderid
			// 	})
			// 	this.$api.collection.sendjindieDetail({ids:ids}).then(()=>{
			// 		this.loading = false
			// 		this.customreload()
			// 	},()=>{
			// 		this.loading = false
			// 	})
				
			// },
			// join() {
			// 	let data = this.$refs[this.reportName + '_list'].getCheckboxRecords()
			// 	if (data.length == 0) {
			// 		this.$message.error('请选择订单')
			// 		return
			// 	}
			// 	let errordata = data.findIndex((item) => {
			// 		return !item.ordercode
			// 	})
			// 	if (errordata !== -1) {
			// 		this.$message.error('订单编码不存在')
			// 		return
			// 	}
			// 	let paymanbuff = data[0].payman
			// 	data.forEach((item) => {
			// 		if (item.payman != paymanbuff) {
			// 			paymanbuff = false
			// 		}
			// 	})
			// 	if (!paymanbuff) {
			// 		this.$message.error('收款单位不唯一')
			// 		return
			// 	}
			// 	let ordercode = []
			// 	data.forEach((item) => {
			// 		ordercode.push(item.ordercode)
			// 	})
			// 	this.$confirm('是否确认合并收款单？', '提示', {
			// 		confirmButtonText: '是',
			// 		cancelButtonText: '否',
			// 		type: 'warning'
			// 	}).then(() => {
			// 		this.$api.collection.joinorder(data[0].id, {
			// 			ordercode: ordercode,
			// 		}).then(() => {
			// 			this.customreload()
			// 		})
			// 	}).catch(() => {
				
			// 	})
			// 	console.log(ordercode)
			// },
			synchronous() {
				let checkrows =  this.$refs[this.reportName+'_list'].getCheckboxRecords()
				let rows = checkrows.filter((item)=>{
					return item.ordercode
				})
				//console.log(checkrows,rows)
				if(rows.length==0){
					this.$message.error('订单编码不存在')
					return
				}
				rows.forEach((item)=>{
					this.listTrades(item.ordercode).then((res) => {
						if (res) {
							let fatherOrderCode = this.findFather(res[0].logs)
							let parentordercode = fatherOrderCode ? fatherOrderCode : res[0]
								.salercpt_no
							let outboundid = res[0].outbound && res[0].outbound.length != 0 ?
								res[0].outbound[0].billID :
								null
							let outboundcode = res[0].outbound && res[0].outbound.length != 0 ?
								res[0].outbound[0].billCode :
								null
							let needamount = res[0].real_payment
							this.loading = true
							this.$api.collection.updateCollectionOrder(item.collectionorderid, {
								parentordercode: parentordercode,
								outboundid: outboundid,
								outboundcode: outboundcode,
								needamount: needamount
							}).then(() => {
								this.loading = false
								this.customreload()
							})
						}
					})
				})
			},
			reconciliation(row) {
				let parentordercode = row.parentordercode
				if (!parentordercode) {
					this.$confirm('父级订单不存在，是否同步', '提示', {
						confirmButtonText: '是',
						cancelButtonText: '否',
						type: 'warning'
					}).then(() => {
						this.synchronous(row)
					}).catch(() => {

					})
					return

				}
				let fullData = [row]
				this.listTrades(parentordercode).then((res) => {
					this.$refs.reconciliation.wlnorder = res[0]
					this.$api.collection.getReceivedpayment(parentordercode).then((res) => {
						this.$refs.reconciliation.parentordercode = parentordercode
						this.$refs.reconciliation.erporder = res
						this.$refs.reconciliation.tableorder = fullData
						this.$refs.reconciliation.code = row.code
						this.$refs.reconciliation.modalshow()
					})
				})
			},
			listTrades(ordercode) {
				this.loading = true
				return new Promise((reslove) => {
					let id = ordercode
					let param = {}
					if (Array.isArray(ordercode)) {
						param = {
							ordercode: ordercode.join(',')
						}
					}
					this.$api.collection.listTrades(id, param).then((res) => {
						let data = res.data
						if (data.length == 0) {
							this.$message.error('暂无订单信息')
						} else {
							this.loading = false
							reslove(data)
						}
					}, () => {
						reslove(null)
						this.loading = false
					})
				})
			},
			toinvoiceoutput() {
				let data = this.$refs[this.reportName + '_list'].getCheckboxRecords()
				if (data.length == 0) {
					this.$message.error('请选择订单')
					return
				}
				let errordata = data.findIndex((item) => {
					return !item.ordercode
				})
				if (errordata !== -1) {
					this.$message.error('订单编码不存在')
					return
				}
				let paymanbuff = data[0].payman
				data.forEach((item) => {
					if (item.payman != paymanbuff) {
						paymanbuff = false
					}
				})
				if (!paymanbuff) {
					this.$message.error('收款单位不唯一')
					return
				}
				let ordercode = []
				data.forEach((item) => {
					ordercode.push(item.ordercode)
				})
				this.formModule = {
					windowName: '添加销项',
					id: 0,
					name: 'invoiceoutput',
					controlltype: 1,
					extra: {
						ordercode: ordercode.join(','),
						row: data
					}
				}
				this.formwindowShow = true
				// this.listTrades(ordercode).then((res)=>{
				// 	console.log(res)

				// })

			},
			findFather(logs) {
				let keyword = '父单号：'
				if (!(logs && logs.length)) {
					return false
				}
				let father = logs.filter((item) => {
					return item.logContent.includes(keyword)
				})
				if (father.length == 0) {
					return false
				}
				let keywordIndex = father[0].logContent.indexOf(keyword)
				let fatherOrderCode = father[0].logContent.substring(keywordIndex + keyword.length)
				if (!fatherOrderCode) {
					return false
				}
				return fatherOrderCode
			},
			// exportApi() {
			// 	this.ids = []
			// 	let obj = {
			// 		ids: this.ids,
			// 		type: this.exportType,
			// 	}
			// 	obj = {
			// 		...obj,
			// 		...this.exportParam
			// 	}
			// 	if (obj.type == 'current') {
			// 		this.exportcurrent()
			// 	} else {
			// 		this.ids = []
			// 	}
			// 	this.loading = true


			// 	this.$api.report.reportexport(this.reportName, obj).then((res) => {
			// 		this.alterexport(res)
			// 		this.$refs[this.exportRef].exportData(res)
			// 		this.loading = false
			// 	}, () => {
			// 		this.loading = false
			// 	})
			// 	this.ids = []
			// },
		},
		components: {
			exportTable,
			reconciliation,
			invoiceConfig
		}
	}
</script>
